import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import notificationService from '../services/notificationService';

const NotificationTest = () => {
  const { userProfile, session } = useAuth();
  const [testing, setTesting] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState(
    typeof window !== 'undefined' && 'Notification' in window 
      ? Notification.permission 
      : 'default'
  );

  const handleTestNotification = async () => {
    setTesting(true);
    try {
      const token = userProfile?.token || session?.access_token;
      if (!token) {
        alert('No authentication token available');
        return;
      }

      const result = await notificationService.testNotification(token);
      if (result?.success) {
        alert('Test notification sent successfully!');
      } else {
        alert('Failed to send test notification');
      }
    } catch (error) {
      console.error('Test notification error:', error);
      alert('Error sending test notification');
    } finally {
      setTesting(false);
    }
  };

  const handleRequestPermission = async () => {
    try {
      if (!('Notification' in window)) {
        alert('Notifications are not supported in this browser');
        return;
      }
      const permission = await Notification.requestPermission();
      setPermissionStatus(permission);
      
      if (permission === 'granted') {
        alert('Notification permission granted!');
        // Re-initialize notifications
        const token = userProfile?.token || session?.access_token;
        if (token) {
          await notificationService.initializeNotifications(token);
        }
      } else {
        alert('Notification permission denied');
      }
    } catch (error) {
      console.error('Error requesting permission:', error);
      alert('Error requesting notification permission');
    }
  };

  const getPermissionStatusColor = (status) => {
    switch (status) {
      case 'granted': return 'text-green-600';
      case 'denied': return 'text-red-600';
      case 'default': return 'text-yellow-600';
      default: return 'text-gray-600';
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        🔔 Push Notifications Test
      </h3>
      
      <div className="space-y-4">
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            Notification Permission Status:
          </p>
          <span className={`font-medium ${getPermissionStatusColor(permissionStatus)}`}>
            {permissionStatus.toUpperCase()}
          </span>
        </div>

        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            FCM Token:
          </p>
          <p className="text-xs font-mono bg-gray-100 dark:bg-gray-700 p-2 rounded break-all">
            {notificationService.getToken() || 'Not available'}
          </p>
        </div>

        <div className="flex gap-3">
          {permissionStatus !== 'granted' && (
            <button
              onClick={handleRequestPermission}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            >
              Request Permission
            </button>
          )}
          
          <button
            onClick={handleTestNotification}
            disabled={testing || permissionStatus !== 'granted'}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {testing ? 'Sending...' : 'Send Test Notification'}
          </button>
        </div>

        <div className="text-xs text-gray-500 dark:text-gray-400">
          <p>• Make sure you have notification icons in the public folder</p>
          <p>• Check browser console for detailed logs</p>
          <p>• VAPID key needs to be configured in firebase-config.js</p>
        </div>
      </div>
    </div>
  );
};

export default NotificationTest;
